// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepError_error__UL8A9 {
  color: white;
  text-align: center;
  padding: 2rem;
  max-width: 400px;
  margin: 0 auto;
}

.StepError_error__UL8A9 button {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/StepError/StepError.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".error {\n  color: white;\n  text-align: center;\n  padding: 2rem;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.error button {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `StepError_error__UL8A9`
};
export default ___CSS_LOADER_EXPORT___;
